import { render, staticRenderFns } from "./StudentPostCreate.vue?vue&type=template&id=03e33654&scoped=true"
import script from "./StudentPostCreate.vue?vue&type=script&lang=js"
export * from "./StudentPostCreate.vue?vue&type=script&lang=js"
import style0 from "./StudentPostCreate.vue?vue&type=style&index=0&id=03e33654&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03e33654",
  null
  
)

export default component.exports